firebird.factory('vdiService', [
    '$rootScope',
    '$timeout',
    'meetingService',
    'helperService',
    '$window',
    function ($rootScope, $timeout, meetingService, helperService, $window) {
        var annotationButtonBounds = null;

        $rootScope.$on('vdi-toggle-annotation-ui', onVdiToggleAnnotationUi);
        $rootScope.$on('vdi-reshow-annotation-ui', onVdiReshowAnnotationUi);
        $rootScope.$on('window-is-resized', windowIsResized);

        var service = {
            setAnnotationButtonBounds: setAnnotationButtonBounds,
            onVdiToggleAnnotationUi: onVdiToggleAnnotationUi
        };

        return service;

        function windowIsResized() {
            if (annotationButtonBounds) {
                $timeout(() => {
                    helperService.getVDIRef().addClipRect(annotationButtonBounds);
                }, 500);
            }
        }

        function setAnnotationButtonBounds(newBounds) {
            annotationButtonBounds = newBounds;
        }

        function onVdiToggleAnnotationUi(e, hideButton) {
            if (annotationButtonBounds) {
                if (hideButton) {
                    helperService.getVDIRef().removeClipRect(annotationButtonBounds);
                } else {
                    $timeout(() => {
                        helperService.getVDIRef().addClipRect(annotationButtonBounds);
                    }, 800);
                }
            }
        }

        function onVdiReshowAnnotationUi() {
            if (annotationButtonBounds) {
                $window.$('#annotation-button').addClass('hide-pen');
                $timeout(() => {
                    if ($window.$('#annotation-button').hasClass('hide-pen')) {
                        $window.$('#annotation-button').removeClass('hide-pen');
                    }
                    helperService.getVDIRef().addClipRect(annotationButtonBounds);
                }, 1000);
            }
        }
    }
]);
